import React from 'react'
import BackdropImage from '../../img/aerial_background.png'

export default ({ children }) => {
    return (
        <div className="auxiliary-route">
            <div className="backdrop">
                <img src={BackdropImage} alt="" aria-hidden="true" />
                <div className="content">{children}</div>
            </div>
        </div>
    )
}
